import {
  grayColor,
  roseColor,
  primaryColor,
  infoColor,
  successColor,
  whiteColor,
} from "./material-kit-pro-react.jsx";

const loaderStyle = theme => ({
    white: {
        color: whiteColor
    },
    primary: {
        color: primaryColor[0]
    },
    info: {
        color: infoColor[0]
    },
    gray: {
        color: grayColor[0]
    },
    success: {
        color: successColor[0],
    },
    rose: {
        color: roseColor[0],
    },
    customInfo: {
        color: infoColor[8]
    },
    customSuccess: {
        color: successColor[8],
    },
    customRose: {
        color: roseColor[5],
    },
    custom : {
        color: theme.customize.loaderColor
    },
    saving: {
        height: "20px",
        width: "20px",
        "& .MuiCircularProgress-root": {
            height: "20px !important",
            width: "20px !important",
            "& svg": {
                width: "20px",
                height: "20px",
            }
        }
    },
});

export default loaderStyle;
